import { render, staticRenderFns } from "./ScrollSmall.vue?vue&type=template&id=74807ec0&scoped=true"
import script from "./ScrollSmall.vue?vue&type=script&lang=js"
export * from "./ScrollSmall.vue?vue&type=script&lang=js"
import style0 from "./ScrollSmall.vue?vue&type=style&index=0&id=74807ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74807ec0",
  null
  
)

export default component.exports